import { produce } from 'immer';

import { Type } from './actions';

const INITIAL_STATE = {
  loading: false,
  playerADX: null,
  selected: null,
  destinos: null,
  isPlaying: false,
  isPlayingBetween: false,
  error: null,
};

export default function player(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case Type.INSERT_REQUEST:
        draft.playerADX = action.payload.playerADX;
        draft.selected = action.payload.pendente;
        draft.destinos = action.payload.destinos;
        draft.isPlaying = false;
        draft.isPlayingBetween = false;
        draft.loading = true;
        draft.error = null;
        break;
      case Type.INSERT_SUCCESS:
        draft.playerADX = { ...draft.playerADX, ...action.payload.data };
        draft.loading = false;
        break;
      case Type.PLAYBETWEEN_REQUEST:
        draft.isPlaying = false;
        draft.isPlayingBetween = false;
        break;
      case Type.PLAYBETWEEN_SUCCESS:
        draft.isPlayingBetween = true;
        draft.playerADX.current = action.payload.current;
        break;
      case Type.PLAY_SUCCESS:
        draft.isPlaying = true;
        break;
      case Type.PAUSE_REQUEST:
        draft.isPlaying = false;
        draft.isPlayingBetween = false;
        break;
      case Type.PAUSE_SUCCESS:
        draft.isPlaying = false;
        draft.isPlayingBetween = false;
        break;
      case Type.SETPOSITION_REQUEST:
        draft.isPlaying = false;
        draft.isPlayingBetween = false;
        break;
      case Type.SETPOSITION_SUCCESS:
        draft.playerADX.current = action.payload.current;
        break;
      case Type.STEP_SUCCESS:
        draft.playerADX.current = action.payload.current;
        draft.isPlaying = false;
        draft.isPlayingBetween = false;
        break;
      case Type.SETMARK_SUCCESS:
        draft.playerADX.markin_frame = action.payload.markin_frame;
        draft.playerADX.markout_frame = action.payload.markout_frame;
        draft.playerADX.markin_tc = action.payload.markin_tc;
        draft.playerADX.markout_tc = action.payload.markout_tc;
        draft.playerADX.duration = action.payload.duration;
        break;

      case Type.GETPOSITION_SUCCESS:
        // Caso esteja tocando o between
        if (
          draft.playerADX.current === draft.playerADX.markout_frame &&
          draft.isPlayingBetween === true
        ) {
          draft.isPlayingBetween = false;
          draft.isPlaying = false;
        }

        if (
          draft.playerADX.current === draft.playerADX.last_frame &&
          draft.isPlaying
        ) {
          draft.isPlaying = false;
        }
        draft.playerADX.current = action.payload.current;
        break;
      case Type.FAILURE:
        draft.loading = false;
        draft.isPlaying = false;
        draft.isPlayingBetween = false;
        draft.error = action.payload.error;
        break;
      case Type.CLEAR:
        draft.loading = false;
        draft.playerADX = null;
        draft.selected = null;
        draft.destinos = null;
        draft.isPlaying = false;
        draft.isPlayingBetween = false;
        draft.error = null;
        break;
      default:
        return state;
    }
  });
}
